export const environment = {
    name: 'STAGING',
    apiServer: 'https://zzq5l60h08.execute-api.ap-southeast-1.amazonaws.com',
    validWebApiHost: 'localhost:4254',
    youtubeApiKey: 'AIzaSyDzyBM5OwHrVaKzV547sKrEcHNB7EL3ZiE',
    firebase: {
        // ===== PRODUCTION ===== We will use production firebase since mobile staging app is using production firebase.
        // apiKey: 'AIzaSyA2QkNQeHyB1DtTxpArAm7EnZksKxroNn0',
        // authDomain: 'interseed-aae48.firebaseapp.com',
        // databaseURL: 'https://interseed-aae48.firebaseio.com',
        // projectId: 'interseed-aae48',
        // storageBucket: 'interseed-aae48.firebasestorage.app',
        // messagingSenderId: '275068157847',
        // appId: '1:275068157847:web:62702343470facd3cfced2',
        // measurementId: 'G-05LD6WSQ29',
        // ===== STAGING ===== Below is staging firebase config.
        apiKey: 'AIzaSyDAE4lblPi8tQDZO28scS3AR2UGll9bXGE',
        authDomain: 'interseed-staging.firebaseapp.com',
        databaseURL: 'https://interseed-staging.firebaseio.com',
        projectId: 'interseed-staging',
        storageBucket: 'interseed-staging.firebasestorage.app',
        messagingSenderId: '629720391751',
        appId: '1:629720391751:web:8d636a6ddc57ba98bc9162',
        measurementId: 'G-92F3D401GN',
    },
};
